import { Grid } from '@mui/material';
import FinancialGrantsGrid from './financialGrantsGrid.view';
import AddEditFinancialGrantsView from './addEditFinancialGrants.view';

const FinancialGrants = () => {
  return (
    <Grid container spacing={{ xs: 1, sm: 2 }} data-testid="financial-grants-container">
      <Grid item xs={12}>
        <FinancialGrantsGrid />
      </Grid>
      <AddEditFinancialGrantsView />
    </Grid>
  );
};

export default FinancialGrants;
